import GeneratedDataImportServiceApi from "./generated/GeneratedDataImportServiceApi"

class DataImportServiceApi extends GeneratedDataImportServiceApi {

}

export const dataImportServiceApi = new DataImportServiceApi()
